const animator = {

	elem: {
		cards: document.querySelectorAll('.card, .page-grid__item, .stats .stat-card'),
		featured: document.querySelectorAll('#main > .wrapper .featured__card'),
		sections: document.querySelectorAll('#main > .wrapper > .component:not(.featured)')
	},

	cardObserver: null,
	featuredObserver: null,
	sectionObserver: null,
	
	init() {
		
		if (animator.elem.cards.length > 0) {
			animator.cardObserver = new IntersectionObserver(animator.animateCard, { root: null, rootMargin: '-100px 0px', threshold: 0 });			
			animator.elem.cards.forEach(function(element) {
				element.classList.add('animateCard', 'animateCard--start');
				animator.cardObserver.observe(element);
			});
		}
		
		if (animator.elem.featured.length > 0) {
			animator.featuredObserver = new IntersectionObserver(animator.animateFeatured, { root: null, rootMargin: '-100px 0px', threshold: 0 });			
			animator.elem.featured.forEach(function(element) {
				element.classList.add('animateSection', 'animateSection--start');
				animator.featuredObserver.observe(element);				
			});
		}
		
		if (animator.elem.sections.length > 0) {
			animator.sectionObserver = new IntersectionObserver(animator.animateSection, { root: null, rootMargin: '-100px 0px', threshold: 0 });			
			animator.elem.sections.forEach(function(element) {
				element.classList.add('animateSection', 'animateSection--start');
				animator.sectionObserver.observe(element);				
			});
		}

		
	},

	animateCard(entries) {
		entries.forEach(entry => {
			if(entry.isIntersecting) {
				entry.target.classList.remove('animateCard--start');
				animator.cardObserver.unobserve(entry.target);
			}
		});
	},

	animateFeatured(entries) {
		entries.forEach(entry => {
			if(entry.isIntersecting) {
				entry.target.classList.remove('animateSection--start');
				animator.featuredObserver.unobserve(entry.target);
			}
		});
	},
	
	animateSection(entries) {
		entries.forEach(entry => {
			if(entry.isIntersecting) {
				entry.target.classList.remove('animateSection--start');
				animator.sectionObserver.unobserve(entry.target);
			}
		});
	}
	
};

export { animator };
